import React, { useReducer } from "react";
import AdminContext from "./adminContext";
import AdminReducer from "./adminReducer";
import clienteAxios from "../../config/axios";
import tokenAuth from "../../config/tokenAuth";
import {
  ELIMINAR_PEDIDO,
  ELIMINAR_PEDIDO_ERROR,
  OBTENER_PEDIDOS_ACTIVO,
  OBTENER_PEDIDOS_ACTIVO_ERROR,
  FINALIZAR_PEDIDO_ERROR,
  FINALIZAR_PEDIDO,
  DESPACHAR_PEDIDO,
  DESPACHAR_PEDIDO_ERROR,
  RESET_STATE,
  DIALOG,
  ELIMINAR_MENU_PEDIDO,
  ELIMINAR_MENU_PEDIDO_ERROR,
  AGREGAR_MENU_PEDIDO,
  AGREGAR_MENU_PEDIDO_ERROR,
  AGREGAR_PEDIDO,
  AGREGAR_PEDIDO_ERROR,
  EDITAR_CARTA,
  EDITAR_CARTA_ERROR,
  AGREGAR_CARTA,
  AGREGAR_CARTA_ERROR,
  ELIMINAR_ITEM,
  ELIMINAR_ITEM_ERROR,
  SUBIR_CARTA,
  FACTURACION,
} from "../../types/index";

const AdminState = (props) => {
  const initialState = {
    pedidos: null,
    despachosSalon: [],
    platos: [],
    ingredientes: [],
    bebidas: [],
    mensaje: null,
    error: null,
    orden: null,
    open: false,
    error_pedido: null,
    historial: [],
  };

  const [state, dispatch] = useReducer(AdminReducer, initialState);

  //FUNCIONES DE NUESTRO STATE
  //ABRIR DIALOG DE CONFIRMACION
  const setOpenDialog = async (boolean) => {
    dispatch({
      type: DIALOG,
      payload: boolean,
    });
  };
  const getActivePedidos = async () => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);

    try {
      const respuesta = await clienteAxios("/api/pedidos/active");
      dispatch({
        type: OBTENER_PEDIDOS_ACTIVO,
        payload: respuesta.data.pedidos.reverse(),
      });
    } catch (error) {
      if (error.response) {
        dispatch({
          type: OBTENER_PEDIDOS_ACTIVO_ERROR,
          payload: error.response.data.msg,
        });
      }
      if (error.message) {
        dispatch({
          type: OBTENER_PEDIDOS_ACTIVO_ERROR,
          payload: error.message,
        });
      }
    }
  };

  const despacharPedido = async (pedido) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      const respuesta = await clienteAxios.put(
        `/api/pedidos/despachar/${pedido._id}`
      );

      dispatch({
        type: DESPACHAR_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log(error);
      console.log(error.message);
      if (error.message) {
        dispatch({
          type: DESPACHAR_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: DESPACHAR_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  const finalizarPedido = async (pedido, precio, pago) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      const datos = {
        precio_total: precio,
        forma_pago: pago,
      };
      const respuesta = await clienteAxios.put(
        `/api/pedidos/finalizar/${pedido._id}`,
        datos
      );
      dispatch({
        type: FINALIZAR_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log(error);
      if (error.message) {
        dispatch({
          type: FINALIZAR_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: FINALIZAR_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //REINICIAR STATE DE MENSAJES
  const resetMensaje = (async) => {
    dispatch({
      type: RESET_STATE,
    });
  };
  //ELIMINA PEDIDO
  const deletePedido = async (pedido) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);

    try {
      const respuesta = await clienteAxios.delete(
        `/api/pedidos/admin/${pedido._id}`
      );
      dispatch({
        type: ELIMINAR_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log({ error });
      if (error.message) {
        dispatch({
          type: ELIMINAR_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: ELIMINAR_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //AGREGAR MENU AL PEDIDO DELIVERY
  const addMenuDelivery = async (pedido, menu) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);

    try {
      const respuesta = await clienteAxios.put(
        `/api/pedidos/add_menu/${pedido._id}`,
        menu
      );
      dispatch({
        type: AGREGAR_MENU_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      if (error.message) {
        dispatch({
          type: AGREGAR_MENU_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: AGREGAR_MENU_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //QUITAR MENU DEL PEDIDO
  const deleteMenu = async (pedido, menu) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      const respuesta = await clienteAxios.put(
        `/api/pedidos/delMenu/${pedido._id}`,
        { _id: menu }
      );

      dispatch({
        type: ELIMINAR_MENU_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log({ error });
      if (error.message) {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          paylaod: error.message,
        });
      } else {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //AGREGAR UN DELIVERY
  const crearPedido = async (
    menu,
    domicilio,
    formaentrega,
    formaPago,
    precio_final,
    clienteManual
  ) => {
    const token = localStorage.getItem("token");
    if (token) {
      tokenAuth(token);
    }
    let pedido = {};
    if (formaentrega) pedido.tipo = formaentrega;
    if (menu) pedido.menu = menu;
    if (precio_final) pedido.precio_total = precio_final;
    if (clienteManual) pedido.cliente_manual = clienteManual;
    if (domicilio) pedido.domicilio = domicilio.calle;
    if (domicilio) pedido.barrio = domicilio.barrio;
    if (domicilio.referencia) pedido.referencia = domicilio.referencia;
    if (formaPago) pedido.forma_pago = formaPago;
    try {
      const respuesta = await clienteAxios.post(`/api/pedidos`, pedido);
      dispatch({
        type: AGREGAR_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log(error);
      if (error.message) {
        dispatch({
          type: AGREGAR_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: AGREGAR_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //MODIFCAR ITEM DE CARTA
  const editItem = async (item) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      let ruta = null;

      if (item.tipo === "plato") {
        ruta = `/api/platos/${item._id}`;
      }
      if (item.tipo === "ingrediente") {
        ruta = `/api/ingredientes/${item._id}`;
      }
      if (item.tipo === "bebida") {
        ruta = `/api/bebidas/${item._id}`;
      }

      await clienteAxios.put(ruta, item);
      dispatch({
        type: EDITAR_CARTA,
        payload: "Carta modificada satisfactoriamente",
      });
    } catch (error) {
      console.log(error);
      if (error.message) {
        dispatch({
          type: EDITAR_CARTA_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: EDITAR_CARTA_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //AGREGAR ITEM CARTA
  const addItem = async (item) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      let ruta = null;
      console.log(item.tipo);
      if (item.tipo === "plato") {
        ruta = `/api/platos`;
      }
      if (item.tipo === "ingrediente") {
        ruta = `/api/ingredientes`;
      }
      if (item.tipo === "bebida") {
        ruta = `/api/bebidas`;
      }
      const respuesta = await clienteAxios.post(ruta, item);
      dispatch({
        type: AGREGAR_CARTA,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log(error);
      if (error.message) {
        dispatch({
          type: AGREGAR_CARTA_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: AGREGAR_CARTA_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //ELIMINAR BEBIDAS DEL PEDIDO SALON
  const delBebida = async (pedido, idMenu, idBebida) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    const datos = {
      idMenu: idMenu,
      idBebida: idBebida,
    };
    try {
      const respuesta = await clienteAxios.put(
        `/api/pedidos/del_bebidaPedido/${pedido._id}`,
        datos
      );
      dispatch({
        type: ELIMINAR_MENU_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log(error);
      if (error.message) {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //AGREGAR MENSAJE POR SOCKET
  const setMensaje = (mensaje) => {
    dispatch({
      type: AGREGAR_PEDIDO,
      payload: `${mensaje.pedido} ${mensaje.creador}`,
    });
  };
  //ELIMINAR ITEM CARTA
  const confirmDelete = async (item) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      let ruta = null;

      if (item.tipo === "plato") {
        ruta = `/api/platos/${item._id}`;
      }
      if (item.tipo === "ingrediente") {
        ruta = `/api/ingredientes/${item._id}`;
      }
      if (item.tipo === "bebida") {
        ruta = `/api/bebidas/${item._id}`;
      }

      const respuesta = await clienteAxios.delete(ruta, item);
      dispatch({
        type: ELIMINAR_ITEM,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log(error);
      console.log(error.message);
      console.log(error.response);

      if (error.response) {
        dispatch({
          type: ELIMINAR_ITEM_ERROR,
          payload: error.response.data.msg,
        });
      } else {
        dispatch({
          type: ELIMINAR_ITEM_ERROR,
          payload: "Error en el server intente mas tarde",
        });
      }
    }
  };
  //ELIMINAR INGREDIENTES DEL PEDIDO SALON
  const delIngrediente = async (pedido, idMenu, idIngrediente) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    const datos = {
      idMenu: idMenu,
      idIngrediente: idIngrediente,
    };
    try {
      const respuesta = await clienteAxios.put(
        `/api/pedidos/del_ingrediente/${pedido._id}`,
        datos
      );
      dispatch({
        type: ELIMINAR_MENU_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
  
      if (error.message) {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //CERRAR PEDIDO
  const closeMesa = async (pedido) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      const respuesta = await clienteAxios.put(
        `/api/pedidos/cerrar/${pedido._id}`
      );
      dispatch({
        type: FINALIZAR_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log(error);
      if (error.message) {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //ACTUALIZAR PAGO Y FORMA DE PAGO
  const actualizarPago = async (pedido, precio, pago) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      const datos = {
        precio_total: precio,
        forma_pago: pago,
      };
      const respuesta = await clienteAxios.put(
        `/api/pedidos/actualizar/${pedido._id}`,
        datos
      );
      dispatch({
        type: FINALIZAR_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      console.log(error);
      if (error.message) {
        dispatch({
          type: FINALIZAR_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: FINALIZAR_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //SUBIR CARTA PDF
  const uploadCarta = async (mensaje) => {
    dispatch({
      type: SUBIR_CARTA,
      payload: mensaje,
    });
  };
  //LISTAR PEDIDOS PARA FACTURACION
  const getAllPedidos = async () => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      const respuesta = await clienteAxios("/api/pedidos/all");

      dispatch({
        type: FACTURACION,
        payload: respuesta.data.pedidos,
      });
    } catch (error) {
      console.log(error);
      if (error.message) {
        dispatch({
          type: OBTENER_PEDIDOS_ACTIVO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: OBTENER_PEDIDOS_ACTIVO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };
  //CANCELAR CIERRE DE MESA
  const anule = async (pedido) => {
    const token = localStorage.getItem("token");
    if (token) tokenAuth(token);
    try {
      const respuesta = await clienteAxios.put(
        `/api/pedidos/anular/${pedido._id}`
      );
      dispatch({
        type: FINALIZAR_PEDIDO,
        payload: respuesta.data.msg,
      });
    } catch (error) {
      
      if (error.message) {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.message,
        });
      } else {
        dispatch({
          type: ELIMINAR_MENU_PEDIDO_ERROR,
          payload: error.response.data.msg,
        });
      }
    }
  };

  return (
    <AdminContext.Provider
      value={{
        pedidos: state.pedidos,
        despachosSalon: state.despachosSalon,
        platos: state.platos,
        ingedientes: state.ingredientes,
        bebidas: state.bebidas,
        cargando: state.cargando,
        mensaje: state.mensaje,
        orden: state.orden,
        error: state.error,
        open: state.open,
        error_pedido: state.error_pedido,
        historial: state.historial,
        getActivePedidos,
        despacharPedido,
        finalizarPedido,
        resetMensaje,
        deletePedido,
        deleteMenu,
        setOpenDialog,
        addMenuDelivery,
        crearPedido,
        editItem,
        addItem,
        delBebida,
        setMensaje,
        confirmDelete,
        delIngrediente,
        closeMesa,
        actualizarPago,
        uploadCarta,
        getAllPedidos,
        anule
      }}
    >
      {props.children}
    </AdminContext.Provider>
  );
};

export default AdminState;
